<c11n-button [size]="size" labelText="Compare" colorMode="on-light" variant="secondary"
 (clickEvent)="compareFunds()"></c11n-button>